export enum RegistrationOption {
  NONE = 'NONE',
  EXISTING = 'EXISTING',
  NEW = 'NEW'
}
